import MobileReg from "./MobileReg"

export default  MobileReg;
